import { DisconnectButton } from '@/domains/header/components/Header/HeaderActions/WalletButton/DisconnecctButton.tsx'
import { CloseButton } from '@/domains/header/components/Header/HeaderActions/WalletButton/CloseButton.tsx'
import { WalletAsset } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset'
import { useModalControlStore } from '@/domains/header/model/store.ts'
import { Popover, PopoverClose, PopoverContent, PopoverOverlay, PopoverPortal, PopoverTrigger } from '@lair-finance/uikit'
import { useResponsive } from '@/shared/hooks/useResponsive.ts'
import { ConnectedButton } from '@/domains/header/components/Header/HeaderActions/WalletButton/ConnectedButton.tsx'

export function WalletButton() {
  const isDesktop = useResponsive('desktop')
  const [activeModal, openModal] = useModalControlStore(state => [state.activeModal, state.openModal, state.closeModal])

  const trigger = <ConnectedButton focus={activeModal === 'wallet'} />
  const content = (
    <div
      className={
        'relative inline-flex flex-col w-screen md:w-[480px] bg-greyscale-600 border border-greyscale-500 md:rounded-[16px] overflow-x-hidden overflow-y-auto invisible-scrollbar'
      }
    >
      <CloseButton className={'max-md:hidden absolute top-[11px] right-3'} />
      <p className={'max-md:hidden flex-center h-[62px] typo-new-head-2 text-greyscale-100 border-b border-greyscale-500'}>Wallet</p>

      <div className={'flex flex-col p-[19px]'}>
        <WalletAsset className={'mb-5 lg:mb-6'} />
        <DisconnectButton />
      </div>
    </div>
  )

  return (
    <Popover open={activeModal === 'wallet'} onOpenChange={open => openModal(open ? 'wallet' : null)}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      {!isDesktop && (
        <PopoverPortal>
          <PopoverClose asChild>
            <PopoverOverlay />
          </PopoverClose>
        </PopoverPortal>
      )}
      <PopoverContent sideOffset={isDesktop ? 4 : 14} side={'bottom'} align={'end'} preventCloseOnOutsideClick noStyle>
        {content}
      </PopoverContent>
    </Popover>
  )
}
